"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var flattenDeep = require('lodash/flattenDeep');

var Highlight = require('./Highlight');

function CustomSamplesShipment(_ref) {
  var shipment = _ref.shipment;
  var shipping_address = shipment.shipping_address,
      products = shipment.products,
      notes = shipment.notes;
  var firstname = shipping_address.firstname,
      lastname = shipping_address.lastname,
      street1 = shipping_address.street1,
      street2 = shipping_address.street2,
      city = shipping_address.city,
      state = shipping_address.state,
      postalCode = shipping_address.postalCode,
      country = shipping_address.country;
  var address_formatted = ["".concat(firstname, " ").concat(lastname), "".concat(street1), street2 ? "".concat(street2) : '', "".concat(city, ", ").concat(state, " ").concat(postalCode), country === 'US' ? '' : "".concat(country)].filter(function (a) {
    return a;
  }).map(function (str) {
    return /*#__PURE__*/React.createElement("span", {
      key: str
    }, str, /*#__PURE__*/React.createElement("br", null));
  });
  var products_formatted = flattenDeep(products.map(function (product) {
    var paper_type = product.paper_type,
        design_name = product.design_name;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "1 - ".concat(design_name, " - ").concat(paper_type)), /*#__PURE__*/React.createElement("br", null));
  }));
  return /*#__PURE__*/React.createElement("span", null, address_formatted, products_formatted, shipment.service, /*#__PURE__*/React.createElement("br", null), notes.map(function (_ref2, i) {
    var text = _ref2.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      key: i
    }, "Note: ", text, /*#__PURE__*/React.createElement("br", null));
  }));
}

CustomSamplesShipment.propTypes = {
  shipment: PropTypes.shape({
    products: PropTypes.array.isRequired,
    shipping_address: PropTypes.shape({
      firstname: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
      street1: PropTypes.string.isRequired,
      street2: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired
    }).isRequired,
    service: PropTypes.string.isRequired,
    notes: PropTypes.array.isRequired
  }).isRequired
};
module.exports = CustomSamplesShipment;